import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsQuestion,
  UpdateNpsQuestion,
  FiltersNpsQuestions
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsQuestionResponse,
  ListNpsQuestionsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsQuestionService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/questions'
  }

  async create(payload: CreateNpsQuestion): Promise<NpsQuestionResponse> {
    const response = await request.post<NpsQuestionResponse>(this.getCompletePath(), payload)
    return response.data
  }

  async update(questionId: number, payload: UpdateNpsQuestion): Promise<NpsQuestionResponse> {
    const response = await request.put<NpsQuestionResponse>(
      `${this.getCompletePath()}/${questionId}`,
      payload
    )
    return response.data
  }

  async getById(questionId: number): Promise<NpsQuestionResponse> {
    const response = await request.get<NpsQuestionResponse>(
      `${this.getCompletePath()}/${questionId}`
    )
    return response.data
  }

  async toggleActive(questionId: number, companyId: number): Promise<NpsQuestionResponse> {
    const response = await request.patch(
      `${this.getCompletePath()}/${questionId}/toggle-active?companyId=${companyId}`,
      {}
    )
    return response.data as NpsQuestionResponse
  }

  async delete(questionId: number): Promise<void> {
    await request.delete(`${this.getCompletePath()}/${questionId}`)
  }

  async list(filters?: FiltersNpsQuestions): Promise<ListNpsQuestionsResponse> {
    try {
      const { data } = await request.get<ListNpsQuestionsResponse>(this.getCompletePath(), filters)
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
